import { Spacer } from "./style";

export default function MobileNavigatorSpace () {
  return(
    <Spacer />
  )
}